// Wanneer de feedbackvraag bij het openen van de app verschijnt (FeedbackPrompt.vue).
// Alles in localStorage, per browser; mislukt lezen/schrijven (bijv. private mode)
// betekent gewoon: niet tonen.

const LAST_SHOWN_KEY = 'vicoma_feedback_prompt_last_shown'
const LAST_RESPONDED_KEY = 'vicoma_feedback_last_responded'
const DISMISSED_KEY = 'vicoma_feedback_prompt_dismissed'

const DAY_MS = 24 * 60 * 60 * 1000
const SHOW_INTERVAL_MS = 30 * DAY_MS // na "Later" of "Geef feedback"
const AFTER_RESPONSE_MS = 90 * DAY_MS // na stemmen of een opmerking

const readTime = (key: string) => {
  try {
    return Number(localStorage.getItem(key)) || 0
  } catch {
    return 0
  }
}

const write = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Opslag niet beschikbaar: dan verschijnt de vraag mogelijk opnieuw, niet erg
  }
}

export function useFeedbackPrompt() {
  const shouldShowPrompt = () => {
    try {
      if (localStorage.getItem(DISMISSED_KEY) === 'true') return false
    } catch {
      return false
    }
    const now = Date.now()
    return now - readTime(LAST_SHOWN_KEY) >= SHOW_INTERVAL_MS && now - readTime(LAST_RESPONDED_KEY) >= AFTER_RESPONSE_MS
  }

  const markPromptShown = () => write(LAST_SHOWN_KEY, String(Date.now()))
  const dismissPromptForever = () => write(DISMISSED_KEY, 'true')
  /** Aanroepen na opgeslagen stemmen of een verstuurde opmerking. */
  const markFeedbackGiven = () => write(LAST_RESPONDED_KEY, String(Date.now()))

  return { shouldShowPrompt, markPromptShown, dismissPromptForever, markFeedbackGiven }
}
